import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Tabs,
    Rate,
    Col,
    Popconfirm,
    Modal,
    Tooltip
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {PlusOutlined, QuestionCircleOutlined, UploadOutlined} from '@ant-design/icons'
import {
    PaperClipOutlined,
    LinkOutlined,
    SendOutlined,
    SearchOutlined,
    ReloadOutlined,
    DownloadOutlined
} from '@ant-design/icons'
import moment from 'moment';
import View1 from '../jf_fz/view'
import View2 from '../jf_wyf/view'
import View3 from '../jf_sf/view'
import View4 from '../jf_df/view'
import View5 from '../jf_zlf/view'
import View6 from '../jf_gnf/view'
import View7 from '../jf_csf/view'
import View8 from '../jf_fwf/view'
import Cuijiao from "../public/cuijiao";


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {
                type: 1
            },
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        // console.log(subtype)
        // return
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Shouye/cuijiao', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (!this.state.newcondition.type) {
                    let newcondition = Object.assign({}, this.state.newcondition, {type: data.type})
                    this.setState({
                        newcondition: newcondition
                    })
                }
                that.setState({
                    list: data.datalist,
                    type_arr: data.type_arr ? data.type_arr : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    onTypeChange(type) {
        let that = this
        let data = Object.assign({}, this.state.newcondition, {type})
        this.setState({
            newcondition: data
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    arrtype(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <a key={item.id} className={`item ` + (this.state.newcondition.type == item.id && 'hover')}
                   onClick={() => this.onTypeChange(item.id)}>{item.name}({item.count})</a>
            )
        }
    }

    render() {
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'company_name',
                key: 'company_name',
            },
            {
                title: '缴费周期',
                dataIndex: 'jfzq',
                key: 'jfzq',
            },
            {
                title: '缴费状态',
                dataIndex: 'status_text',
                key: 'status_text',
                render: (row, record) => {
                    return <>
                        {record.type == 1 || record.type == 2 || record.type == 5 || record.type == 6 ?
                            <>
                                {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                                {record.status == 2 && <Tag color={'blue'}>{row}</Tag>}
                                {record.status == 3 && <Tag color={'red'}>{row}</Tag>}
                                {record.status == 4 && <Tag color={'orange'}>{row}</Tag>}
                                {record.status == 5 && <Tag color={'grey'}>{row}</Tag>}
                            </>
                            :
                            <>
                                {record.status2 == 1 && <Tag color={'green'}>{record.status2_text}</Tag>}
                                {record.status2 == 0 && <Tag color={'red'}>{record.status2_text}</Tag>}
                            </>
                        }
                    </>
                },
            },
            {
                title: '操作',
                dataIndex: 'caicuo',
                key: 'caicuo',
                render: (row, record) => <Space>
                    {record.type == 1 && <View1 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 2 && <View2 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 3 && <View3 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 4 && <View4 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 5 && <View5 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 6 && <View6 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 7 && <View7 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {record.type == 8 && <View8 id={record.id} refresh={this.getdata.bind(this)}/>}
                    {store.getState().data.info.lmqx_bj ? ((store.getState().data.info.lmqx_bj.includes('301') && record.type == 1)||
                        (store.getState().data.info.lmqx_bj.includes('302') && record.type == 2) ||
                        (store.getState().data.info.lmqx_bj.includes('305') && record.type == 5) ||
                        (store.getState().data.info.lmqx_bj.includes('306') && record.type == 6) ||
                        (store.getState().data.info.lmqx_bj.includes('307') && record.type == 7) ||
                        (store.getState().data.info.lmqx_bj.includes('308') && record.type == 8)?
                        <>
                            {record.status == 1 ? null :
                                <Cuijiao company_id={record.company_id}/>}
                        </>
                        : null) : null}
                </Space>,
            },
        ];
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            <div className={'box box4'}>
                <div className={'title'}>
                    <div className={'p1'}>

                        <Space>
                            <span>费用催缴</span>
                            <Tooltip title={'7天内到期且未缴费的'}>
                                <QuestionCircleOutlined />
                            </Tooltip>
                        </Space>
                    </div>
                    <div className={'p2'}>
                        <div className={'fylx'}>
                            <Space size={25}>
                                {this.arrtype(this.state.type_arr)}
                            </Space>
                        </div>
                    </div>
                </div>
                <Table columns={columns} dataSource={this.state.list} style={{width: '100%'}} pagination={false}/>
                <Row justify={'center'} style={{width: '100%'}}>
                    <Pagination showQuickJumper
                                simple
                                current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                                pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 5}
                                total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                                showTotal={total => `共 ${total} 条数据`}/>
                </Row>
            </div>
        </>)
    }
}

export default Index
